<div class="w-100 s7-container">
    <back-to-registries-button></back-to-registries-button>
</div>
<div class="s7-container">
    <div class="s7-page-error-grid">
        <div class="s7-page-error-code">
            <div class="s7-page-error-code-part">
                <span>4</span>
            </div>
            <div class="s7-page-error-code-part">
                <span>0</span>
            </div>
            <div class="s7-page-error-code-part">
                <span>4</span>
            </div>
        </div>
        <div class="s7-page-error-description">
            <div class="s7-page-error-description-row">
                <h2>{{ 'shared:notFoundPage.title' | i18next }}</h2>
            </div>
            <div class="s7-page-error-description-row">{{ 'shared:notFoundPage.description' | i18next }}</div>
            <div class="s7-page-error-description-row">
                {{ 'shared:notFoundPage.needHelp' | i18next }} <a class="link" href="mailto:vm@s7.ru">{{ 'shared:notFoundPage.write' | i18next }}</a>
            </div>
        </div>
    </div>
</div>
